import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface SelectContactEmailDialogData {
  availableEmails: string[];
  currentEmail: string;
}

export namespace SelectContactEmailForm {
  export const FIELD_EMAIL = "email";
}

@Component({
  selector: "app-select-contact-email-dialog",
  templateUrl: "./select-contact-email-dialog.component.html",
})
export class SelectContactEmailDialogComponent {
  constructor(
    private readonly dialogRef: MatDialogRef<SelectContactEmailDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SelectContactEmailDialogData,
  ) {
    const initial = this.data.availableEmails.find(email => email !== this.data.currentEmail)
      || this.data.availableEmails[0]
      || null;
    this.form.patchValue({ [SelectContactEmailForm.FIELD_EMAIL]: initial });
  }

  form = new FormGroup({
    [SelectContactEmailForm.FIELD_EMAIL]: new FormControl(null, Validators.required)
  });

  SelectContactEmailForm = SelectContactEmailForm;

  cancel(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    if (this.form.invalid) return;

    const email = this.form.value[SelectContactEmailForm.FIELD_EMAIL] as string;
    this.dialogRef.close({ email });
  }
}
